<div class="recording-dialog">
  <h2 mat-dialog-title class="mb-0 pb-0">Voice Transcription</h2>

  <mat-dialog-content>
    <!-- Loading / Checking Permission State -->
    @if (permissionPending()) {
      <div class="loading-state">
        <mat-spinner diameter="40"></mat-spinner>
        <p>Requesting microphone permission...</p>
      </div>
    }

    @if (permissionDenied()) {
      <div class="permission-denied">
        <mat-icon color="warn">mic_off</mat-icon>
        <p>Microphone permission denied</p>
        <p class="hint">Please allow microphone access to use voice transcription</p>
        <button mat-raised-button color="primary" (click)="requestPermission()">
          Request Permission
        </button>
      </div>
    }

    @if (permissionStatus() === 'granted') {
      <!-- Recording Interface - Horizontal Bar -->
      @if (finalizing()) {
        <!-- Finalizing: waiting for Deepgram to flush punctuated results -->
        <div class="recording-bar finalizing-bar">
          <mat-spinner diameter="24"></mat-spinner>
          <span class="finalizing-text">Finalizing transcription...</span>
        </div>
      } @else if (isStopped()) {
        <!-- Show playback after recording stops and transcription completes -->
      } @else {
        <!-- Recording/Idle State -->
        <div class="recording-bar">
          <span class="time-display">{{formattedDuration()}}</span>

          <div class="progress-bar-container">
            @if (isRecording()) {
              <div class="waveform-mini">
                @for (amplitude of waveform(); track $index) {
                  <div
                    class="waveform-bar-mini"
                    [style.height.%]="amplitude * 100">
                  </div>
                }
              </div>
            }
          </div>

          @if (preparingToRecord()) {
            <!-- Preparing state: loading spinner while fetching API key -->
            <button
              mat-icon-button
              class="control-button"
              disabled
              aria-label="Preparing...">
              <mat-spinner diameter="24"></mat-spinner>
            </button>
          } @else if (canRecord()) {
            <!-- Ready to record: enabled mic button -->
            <button
              mat-icon-button
              class="control-button"
              (click)="startRecording()"
              aria-label="Start recording">
              <mat-icon>mic</mat-icon>
            </button>
          } @else if (isRecording()) {
            <!-- Recording: stop button -->
            <button
              mat-icon-button
              class="control-button"
              color="warn"
              (click)="stopRecording()"
              aria-label="Stop recording">
              <mat-icon>stop</mat-icon>
            </button>
          }
        </div>
      }

      <!-- Playback Interface -->
      @if (isStopped() && playbackUrl()) {
        <div class="recording-bar">
          <button
            mat-icon-button
            class="control-button"
            (click)="playing() ? pauseAudio() : playAudio()"
            [disabled]="transcribing()"
            aria-label="Play/Pause">
            <mat-icon>{{ playing() ? 'pause' : 'play_arrow' }}</mat-icon>
          </button>

          <span class="time-display">{{formattedPlaybackTime()}}</span>

          <div class="progress-bar-container">
            <div class="progress-bar-fill" [style.width.%]="playbackProgress()"></div>
          </div>

          <button
            mat-icon-button
            class="control-button"
            color="warn"
            (click)="deleteRecording()"
            [disabled]="transcribing()"
            aria-label="Delete recording">
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      }

      <!-- Processing progress bar on divider line -->
      @if (transcribing()) {
        <mat-progress-bar
          mode="indeterminate"
          class="processing-progress">
        </mat-progress-bar>
      }

      <!-- Transcription Text - Always show -->
      <div class="transcription-area">
        <label for="transcriptionText">Transcription</label>
        <textarea
          id="transcriptionText"
          [(ngModel)]="transcriptionText"
          placeholder="Transcribed text will appear here... You can also edit it manually."
          rows="10"
          [disabled]="transcribing()"
        ></textarea>
      </div>
    }
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button (click)="cancel()" [disabled]="transcribing() || finalizing()">Cancel</button>

    <button
      mat-raised-button
      color="primary"
      (click)="insertTranscription()"
      [disabled]="!canInsertTranscription() || transcribing() || isRecording() || finalizing()">
      Insert Transcription
    </button>
  </mat-dialog-actions>
</div>
